"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["variant", "small", "icon", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _mui.makeStyles)()(function (theme, _params, classes) {
  return {
    root: {
      lineHeight: 1,
      borderRadius: 12,
      padding: theme.spacing(0, 2),
      boxShadow: 'none',
      fontWeight: 'bold',
      textTransform: 'none',
      fontSize: theme.typography.button.fontSize,
      minWidth: 170,
      minHeight: 35,
      '&:hover, &:active, &:focus': {
        boxShadow: 'none'
      }
    },
    disabled: {
      color: theme.palette.lightGrey.dark
    },
    sizeSmall: {
      fontSize: theme.typography.buttonSmall.fontSize,
      minWidth: 140,
      minHeight: 30
    },
    containedSecondary: {
      backgroundColor: theme.palette.secondary.light,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main
      }
    },
    outlined: _defineProperty({}, "&.".concat(classes.disabled), {
      border: "2px solid ".concat(theme.palette.lightGrey.dark)
    }),
    outlinedPrimary: {
      border: "2px solid ".concat(theme.palette.primary.main),
      '&:hover': {
        border: "2px solid ".concat(theme.palette.primary.main)
      }
    },
    dangerous: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.red.main,
      '&:hover': {
        backgroundColor: theme.palette.red.dark
      }
    }
  };
});
var variantMap = {
  primary: {
    variant: 'contained',
    color: 'secondary'
  },
  secondary: {
    variant: 'outlined',
    color: 'primary'
  },
  tertiary: {
    variant: 'text',
    color: 'primary'
  },
  dangerous: {
    variant: 'contained'
  }
};
var Button = function Button(props) {
  var variant = props.variant,
    small = props.small,
    icon = props.icon,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, otherProps, {
    classes: classes,
    variant: variantMap[variant].variant,
    color: variantMap[variant].color,
    size: small ? 'small' : 'medium',
    startIcon: icon,
    className: (0, _clsx["default"])(variant === 'dangerous' && classes.dangerous, className)
  }));
};
Button.propTypes = {
  variant: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary', 'dangerous']),
  small: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].node,
  className: _propTypes["default"].string
};
Button.defaultProps = {
  variant: 'primary',
  small: false,
  disabled: false,
  icon: undefined,
  className: undefined
};
var _default = Button;
exports["default"] = _default;